const treatmentItems = [
    "Abhyanga: W\xE4rmevolle Kr\xE4uter\xF6lmassage f\xFCr den ganzen K\xF6rper.",
    "Shiro Abhyanga: Kopfmassage zur Beruhigung des Geistes und tiefen Entspannung.",
    "Vakttra Abhyanga: Gesichtsbehandlung zur Entspannung und sanften Wiederbelebung.",
    "Shirodhara: Sanftes \xD6l \xFCber die Stirn f\xFCr tiefe mentale Ruhe und Erholung.",
    "Nasya Karma: Reinigung der Naseng\xE4nge zur Klarheit von K\xF6rper und Sinne.",
    "Herbal Bath: Dampfbad oder Bad mit Kr\xE4utern und Blumen f\xFCr W\xE4rme und tiefes Entspannen."
];
const activityItems = [
    "Yoga",
    "Qigong",
    "Meditation",
    "Musiktherapie"
];
const AboutPanchakarma = () => {
    return <section
        id="about-panchakarma"
        className="relative isolate overflow-hidden bg-white py-16 sm:py-20 lg:py-24"
    >
        {
            /* Mobile Layout - sm and below */
        }
        <div className="lg:hidden container mx-auto flex flex-col gap-8 px-3 sm:px-5">
            {
                /* Label */
            }
            <span className="inline-flex items-center gap-2 rounded-full border border-amber-200 bg-white/80 px-3 py-2 font-mulish text-xs font-semibold uppercase tracking-[0.14em] text-[#8a5a23] shadow-sm backdrop-blur w-fit">
                Panchakarma
            </span>

            {
                /* Heading */
            }
            <h2 className="font-serif text-2xl font-semibold leading-[1.2] tracking-[-0.03em] text-[#10261a] sm:text-3xl">
                Ganzheitliche Panchakarma-Ayurveda-Behandlung
            </h2>

            <p className="font-serif text-lg font-medium tracking-[-0.02em] text-[#24422f] sm:text-xl">
                Damit Sie Ihre innere Leuchtkraft wiederfinden.
            </p>

            {
                /* Image */
            }
            <div className="relative overflow-hidden rounded-[24px] border border-white/70 bg-white shadow-lg">
                <div className="relative h-[300px] sm:h-[400px]">
                    <img
                        src="/images/Hiru/Hiru Villa's/Hiru Om/DOCTOR & AYURVEDA/DSC09208-Enhanced-NR-Edit-copy.webp"
                        alt="Entspannungsbereich für Panchakarma-Behandlungen"
                        className="object-cover object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#07130d]/55 via-[#07130d]/15 to-transparent" />
                </div>
            </div>

            {
                /* Content */
            }
            <div className="space-y-4">
                <div className="space-y-4 font-mulish text-[15px] leading-7 text-[#334155] sm:text-base">
                    <p>
                        Eine echte Panchakarma-Ayurveda-Behandlung wird von einem warmherzigen Team aus hochqualifizierten Ärzten und Therapeuten durchgeführt, die über umfangreiche Erfahrung verfügen. Die erfahrenen Ärzte beantworten Ihre Fragen gerne und halten regelmäßig kostenlose Einführungen ab, in denen Sie die Grundprinzipien von Ayurveda kennenlernen.
                    </p>
                    <p>
                        Alle Ärzte haben nach ihrem Universitätsabschluss viele Jahre praktische Erfahrung gesammelt und eine spezielle Ausbildung in der Ayurveda-Medizin mit Fokus auf traditionelle Panchakarma-Behandlungen absolviert. Nach Ihrer Ankunft in einem der Hiru Resorts beginnt alles mit einer ausführlichen Erstuntersuchung durch den leitenden Arzt.
                    </p>
                    <p>
                        Diese Diagnose ist eine wichtige Zeit, um auf die Stimme von Körper und Geist zu hören. Auf Basis der Ergebnisse erstellen wir einen individuellen Behandlungsplan und ein passendes Ernährungsprogramm, das genau zu Ihrem aktuellen Zustand passt. Täglich werden mindestens vier verschiedene Behandlungen eingesetzt, um die angesammelte Erschöpfung sanft zu lösen.
                    </p>
                </div>

                <div className="grid gap-2 sm:gap-3 sm:grid-cols-2">
                    {treatmentItems.map((item) => <div
                        key={item}
                        className="rounded-2xl border border-amber-100 bg-white/85 px-3 py-3 shadow-sm shadow-amber-100/40"
                    >
                        <p className="font-mulish text-xs leading-6 text-[#1f2937] sm:text-sm">{item}</p>
                    </div>)}
                </div>

                <div className="rounded-2xl border border-amber-200/70 bg-white/75 p-5 shadow-lg backdrop-blur-sm">
                    <h3 className="font-serif text-lg font-semibold text-[#10261a] sm:text-xl">
                        Aktivitäten zur Harmonisierung
                    </h3>
                    <p className="mt-2 font-mulish text-[15px] leading-7 text-[#475569] sm:text-base">
                        Um die Wirkung der Behandlung zu verstärken, bieten wir regelmäßig Yoga-, Qigong-, Meditations- und Musiktherapie-Programme an. In ruhigen Momenten finden Körper und Geist wieder in eine innere Balance.
                    </p>
                    <div className="mt-3 flex flex-wrap gap-2">
                        {activityItems.map((item) => <span
                            key={item}
                            className="rounded-full border border-emerald-200 bg-[#f8fcf7] px-3 py-1.5 font-mulish text-xs sm:text-sm font-medium text-[#24422f]"
                        >
                            {item}
                        </span>)}
                    </div>
                </div>

                <div className="space-y-3 font-mulish text-[15px] leading-7 text-[#334155] sm:text-base">
                    <p>
                        Zwischen den Behandlungen haben Sie die Möglichkeit, in entspannter Atmosphäre die reiche Kultur Sri Lankas kennenzulernen. Ob UNESCO-Stätten, mystische Tempel oder Bootsausflüge zu traumhaften Seen – wir planen Ausflüge passend zu Ihrem Behandlungsprogramm, damit Sie sich entspannt und sicher bewegen können.
                    </p>
                    <div className="rounded-[20px] border border-[#d8d0bf] bg-[#fffaf1] p-4">
                        <p className="font-serif text-lg font-semibold text-[#10261a]">
                            Reisehinweis
                        </p>
                        <p className="mt-2 leading-7 text-[#475569] text-[15px] sm:text-base">
                            Wenn Sie eine aktivere Reise durch Sri Lanka planen, empfehlen wir Ihnen, diese vor dem Aufenthalt im Resort zu absolvieren. So können Sie die Reisemüdigkeit schon hinter sich lassen und anschließend ganz in Ruhe und Stille bei Hiru Resort regenerieren.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        {
            /* Desktop Layout - lg and above */
        }
        <div className="hidden lg:grid container mx-auto gap-10 px-4 sm:px-6 lg:grid-cols-2 lg:items-center lg:gap-14 lg:px-8">
            <div className="order-2 lg:order-1">
                <div className="relative overflow-hidden rounded-[32px] border border-white/80 bg-white shadow-[0_28px_80px_rgba(15,23,42,0.16)]">
                    <div className="relative min-h-[420px] sm:min-h-[520px] lg:min-h-[760px]">
                        <img
                            src="/images/Hiru/Hiru Villa's/Hiru Om/DOCTOR & AYURVEDA/DSC09208-Enhanced-NR-Edit-copy.webp"
                            alt="Entspannungsbereich für Panchakarma-Behandlungen"
                            className="object-cover object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#07130d]/55 via-[#07130d]/15 to-transparent" />
                        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(255,255,255,0.18),_transparent_38%)]" />
                    </div>

                    <div className="absolute inset-x-4 bottom-4 grid grid-cols-1 gap-3 sm:inset-x-6 sm:grid-cols-2">
                        <div className="rounded-2xl border border-white/20 bg-white/15 p-4 text-white shadow-lg backdrop-blur-md">
                            <p className="font-mulish text-xs uppercase tracking-[0.14em] text-white/75">Beratung</p>
                            <p className="mt-2 font-serif text-2xl font-semibold">Erstdiagnose</p>
                            <p className="mt-1 font-mulish text-sm text-white/85">Individueller Plan nach Körper und Geist</p>
                        </div>
                        <div className="rounded-2xl border border-white/20 bg-white/15 p-4 text-white shadow-lg backdrop-blur-md">
                            <p className="font-mulish text-xs uppercase tracking-[0.14em] text-white/75">Programm</p>
                            <p className="mt-2 font-serif text-2xl font-semibold">Tägliche Pflege</p>
                            <p className="mt-1 font-mulish text-sm text-white/85">Mehrere Therapien für tiefe Erholung</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="order-1 lg:order-2">
                <span className="inline-flex items-center gap-2 rounded-full border border-amber-200 bg-white/80 px-4 py-2 font-mulish text-xs font-semibold uppercase tracking-[0.14em] text-[#8a5a23] shadow-sm backdrop-blur md:text-sm">
                    Panchakarma
                </span>

                <h2 className="mt-5 max-w-2xl font-serif text-3xl font-semibold leading-[1.18] tracking-[-0.03em] text-[#10261a] sm:text-4xl lg:text-5xl">
                    Ganzheitliche Panchakarma-Ayurveda-Behandlung
                </h2>

                <p className="mt-4 font-serif text-2xl font-medium tracking-[-0.02em] text-[#24422f] sm:text-[2rem]">
                    Damit Sie Ihre innere Leuchtkraft wiederfinden.
                </p>

                <div className="mt-6 space-y-5 font-mulish text-base leading-8 text-[#334155] sm:text-lg">
                    <p>
                        Eine echte Panchakarma-Ayurveda-Behandlung wird von einem warmherzigen Team aus hochqualifizierten Ärzten und Therapeuten durchgeführt, die über umfangreiche Erfahrung verfügen. Die erfahrenen Ärzte beantworten Ihre Fragen gerne und halten regelmäßig kostenlose Einführungen ab, in denen Sie die Grundprinzipien von Ayurveda kennenlernen.
                    </p>
                    <p>
                        Alle Ärzte haben nach ihrem Universitätsabschluss viele Jahre praktische Erfahrung gesammelt und eine spezielle Ausbildung in der Ayurveda-Medizin mit Fokus auf traditionelle Panchakarma-Behandlungen absolviert. Nach Ihrer Ankunft in einem der Hiru Resorts beginnt alles mit einer ausführlichen Erstuntersuchung durch den leitenden Arzt.
                    </p>
                    <p>
                        Diese Diagnose ist eine wichtige Zeit, um auf die Stimme von Körper und Geist zu hören. Auf Basis der Ergebnisse erstellen wir einen individuellen Behandlungsplan und ein passendes Ernährungsprogramm, das genau zu Ihrem aktuellen Zustand passt. Täglich werden mindestens vier verschiedene Behandlungen eingesetzt, um die angesammelte Erschöpfung sanft zu lösen.
                    </p>
                </div>

                <div className="mt-8 grid gap-3 sm:grid-cols-2">
                    {treatmentItems.map((item) => <div
                        key={item}
                        className="rounded-2xl border border-amber-100 bg-white/85 px-4 py-4 shadow-sm shadow-amber-100/40"
                    >
                        <p className="font-mulish text-sm leading-7 text-[#1f2937] sm:text-base">{item}</p>
                    </div>)}
                </div>

                <div className="mt-8 rounded-[28px] border border-amber-200/70 bg-white/75 p-6 shadow-[0_18px_50px_rgba(120,92,47,0.08)] backdrop-blur-sm sm:p-7">
                    <h3 className="font-serif text-2xl font-semibold text-[#10261a] sm:text-[1.75rem]">
                        Aktivitäten zur Harmonisierung
                    </h3>
                    <p className="mt-3 font-mulish text-base leading-8 text-[#475569] sm:text-lg">
                        Um die Wirkung der Behandlung zu verstärken, bieten wir regelmäßig Yoga-, Qigong-, Meditations- und Musiktherapie-Programme an. In ruhigen Momenten finden Körper und Geist wieder in eine innere Balance.
                    </p>

                    <div className="mt-5 flex flex-wrap gap-3">
                        {activityItems.map((item) => <span
                            key={item}
                            className="rounded-full border border-emerald-200 bg-[#f8fcf7] px-4 py-2 font-mulish text-sm font-medium text-[#24422f]"
                        >
                            {item}
                        </span>)}
                    </div>
                </div>

                <div className="mt-8 space-y-4 font-mulish text-base leading-8 text-[#334155] sm:text-lg">
                    <p>
                        Zwischen den Behandlungen haben Sie die Möglichkeit, in entspannter Atmosphäre die reiche Kultur Sri Lankas kennenzulernen. Ob UNESCO-Stätten, mystische Tempel oder Bootsausflüge zu traumhaften Seen – wir planen Ausflüge passend zu Ihrem Behandlungsprogramm, damit Sie sich entspannt und sicher bewegen können.
                    </p>
                    <div className="rounded-[24px] border border-[#d8d0bf] bg-[#fffaf1] p-5">
                        <p className="font-serif text-xl font-semibold text-[#10261a]">
                            Reisehinweis
                        </p>
                        <p className="mt-3 leading-8 text-[#475569]">
                            Wenn Sie eine aktivere Reise durch Sri Lanka planen, empfehlen wir Ihnen, diese vor dem Aufenthalt im Resort zu absolvieren. So können Sie die Reisemüdigkeit schon hinter sich lassen und anschließend ganz in Ruhe und Stille bei Hiru Resort regenerieren.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>;
};
export default AboutPanchakarma;
